import { Button } from '../../ui/Button';
import styles from './Dig.module.css';

interface Props {
  channelName: string;
  /** This channel is the one the digs are pinned to */
  pinned: boolean;
  onMore: () => void;
  onLess: () => void;
  onTogglePin: () => void;
}

/** More, Less and Stay on this channel, under the Why line (SPEC F6, channel feedback). 1 tap each. */
export function ChannelFeedback({ channelName, pinned, onMore, onLess, onTogglePin }: Props) {
  return (
    <div className={styles.feedback}>
      <Button variant="tertiary" aria-label={`More from ${channelName}`} onClick={onMore}>More</Button>
      <Button variant="tertiary" aria-label={`Less from ${channelName}`} onClick={onLess}>Less</Button>
      <Button variant="tertiary" aria-pressed={pinned} onClick={onTogglePin}>{pinned ? 'Stop staying' : 'Stay on this channel'}</Button>
    </div>
  );
}
